import React from 'react'
import { LocalizationMap, Viewer, Worker } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import zhCN from '@react-pdf-viewer/locales/lib/zh_CN.json'

import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

export interface PdfViewerProps {
  src: string
  onLoad?: () => void
}
export const PdfViewer: React.VFC<PdfViewerProps> = ({ src, onLoad }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin()
  return (
    <PdfWorkerProvider>
      <Viewer
        fileUrl={src}
        onDocumentLoad={onLoad}
        theme="dark"
        plugins={[defaultLayoutPluginInstance]}
        localization={zhCN as unknown as LocalizationMap}
      />
    </PdfWorkerProvider>
  )
}

export const PdfWorkerProvider: React.FC = ({ children }) => (
  <Worker workerUrl="https://static.marketup.cn/marketup/resources/js/pdf.worker.js">
    {children}
  </Worker>
)
